
export default function Rights() {
  const rights = [
    {
      title: 'Carteira de Trabalho Assinada',
      description: 'Todo trabalhador tem direito ao registro formal em carteira desde o primeiro dia de trabalho, garantindo acesso a todos os benefícios previstos em lei.'
    },
    {
      title: 'Salário e 13º em Dia',
      description: 'O pagamento do salário deve ocorrer até o 5º dia útil do mês seguinte. O 13º salário deve ser pago em duas parcelas: até 30 de novembro e 20 de dezembro.'
    },
    {
      title: 'Férias Remuneradas',
      description: 'Após 12 meses de trabalho, você tem direito a 30 dias de férias com acréscimo de 1/3 do salário. As férias devem ser concedidas nos 12 meses seguintes.'
    },
    {
      title: 'FGTS e Multa Rescisória',
      description: 'O empregador deve depositar mensalmente 8% do salário no FGTS. Em caso de demissão sem justa causa, você tem direito à multa de 40% sobre o saldo.'
    },
    {
      title: 'Jornada de Trabalho',
      description: 'A jornada normal é de até 8 horas diárias e 44 horas semanais. Horas extras devem ser pagas com adicional mínimo de 50% sobre o valor da hora normal.'
    },
    {
      title: 'Intervalo e Descanso',
      description: 'Jornadas acima de 6 horas garantem intervalo mínimo de 1 hora para refeição. O descanso semanal remunerado deve ser de 24 horas consecutivas, preferencialmente aos domingos.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Conheça Seus Direitos Trabalhistas
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            A informação é o primeiro passo para a defesa dos seus direitos. Entenda o que a legislação trabalhista brasileira garante a você.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {rights.map((right, index) => (
            <div 
              key={index}
              className="flex gap-6 p-6 bg-gray-50 rounded-xl hover:bg-[#4A1C40]/5 transition-all duration-300 border border-gray-200"
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A961] rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#4A1C40] mb-2" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  {right.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {right.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#4A1C40] to-[#5A2C50] rounded-2xl p-10 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-[#C9A961] rounded-full mx-auto mb-6">
              <i className="ri-lightbulb-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Seus Direitos Foram Violados?
            </h3>
            <p className="text-gray-100 text-lg mb-6 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              Se você identificou alguma irregularidade na sua relação de trabalho, é fundamental buscar orientação jurídica especializada. 
              A legislação trabalhista existe para proteger você, e há prazos legais que devem ser respeitados.
            </p>
            <p className="text-[#C9A961] font-semibold text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
              O prazo para reclamar direitos trabalhistas é de até 2 anos após o término do contrato, 
              limitado aos últimos 5 anos de trabalho.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
